function f(n){var i,s,c,o,d,t,r;if(!n||!((i=n.nodes)!=null&&i.length))return;const u=Array.from(document.querySelectorAll("[data-key-feature-id]"));for(const l of u){const p=l.dataset.keyFeatureId,e=n.nodes.find(a=>(a==null?void 0:a.id)===p);e&&(l.classList.remove("is-loading"),l.innerHTML=`
      <span class="product-card__meta-icon">
        <img
          src="${((c=(s=e==null?void 0:e.fields)==null?void 0:s.find(a=>a.key==="icon"))==null?void 0:c.reference.image.url)??""}"
          alt="${((d=(o=e==null?void 0:e.fields)==null?void 0:o.find(a=>a.key==="title"))==null?void 0:d.value)??""}"
          width="16"
          height="16"
        />
      </span>
      <span
        class="product-card__meta-label text-s">
        ${((r=(t=e==null?void 0:e.fields)==null?void 0:t.find(a=>a.key==="title"))==null?void 0:r.value)??""}
      </span>
    `)}}function w(n){var i,s,c;if(!n||!((i=n.nodes)!=null&&i.length))return;const u=Array.from(document.querySelectorAll("[data-bundle-collection]"));for(const o of u){const d=o.dataset.bundleCollection,t=n.nodes.find(r=>(r==null?void 0:r.id)===d);if((t==null?void 0:t.__typename)!=="Collection")return;if(!(!t||!((c=(s=t==null?void 0:t.products)==null?void 0:s.nodes)!=null&&c.length))){o.innerHTML="";for(const r of t.products.nodes.slice(0,3))o.innerHTML+=`
        <div class="product-card__meta-feature product-card__meta-feature--bundle">
          <span class="product-card__meta-icon">
          ${window.themeVars.icons.plus}
          </span>
          <span
            class="product-card__meta-label text-s">
            ${r.title}
          </span>
        </div>
      `;t.products.nodes.length>3&&(o.innerHTML+=`
        <div class="product-card__meta-feature product-card__meta-feature--bundle">
          <span class="product-card__meta-icon">
          ${window.themeVars.icons.plus}
          </span>
          <span class="product-card__meta-label text-s">
            ${t.products.nodes.length-3} ${window.themeVars.strings.collection.productCard.more}
          </span>
        </div>
      `)}}}function v(){var i,s,c;const n=Array.from(document.querySelectorAll("sc-comparison-table"));if(!n.length)return;const u=`
    .view-more-button, .product .button {
      background-color: var(--color-brand-secondary);
      font-size: var(--font-size-sm);
      font-weight: var(--weight-book);
      border: none;
      border-radius: var(--spacing-l);
    }

    .row-group--body {
      display: none;
    }
    .row-group--body.visible {
      display: grid;
    }

    .attribute-name, .group-name {
      font-size: var(--spacing-s);
    }

    .attribute-value {
      font-size: var(--spacing-sm);
      font-weight: var(--weight-book);
    }

    .column-header .product :nth-child(1) {
     order: 1;
    }

    .column-header .product :nth-child(2) {
     order: 0;
    }

    .column-header .product :nth-child(3) {
     order: 2;
    }

    .column-header .product :nth-child(4) {
     order: 3;
    }

    .product__info .product__title {
      display: none;
    }

    .product__info .money {
      font-weight: var(--weight-semi);
    }

    .product__image-wrapper {
      max-width: calc(100% - 64px);
      margin: 0 auto;
      mix-blend-mode: multiply;
      background-color: var(--color-background);

      img {
        mix-blend-mode: multiply;
      }
    }

    .product .rating-badge {
      display: none;
    }

    .product {
      align-items: center;
    }
    
    .product__select {
      appearance: none;
      background: url('data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none"%3E%3Cpath d="M5.5 7.5L10.5 12.5L15.5 7.5" stroke="%2325282A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/%3E%3C/svg%3E') no-repeat right 0.5rem center;
      border-color: #D8D8D8;
      font-weight: var(--weight-semi);
      height: fit-content;
      padding: var(--spacing-s);
    }

    @media(max-width: 863px) {
      .product__title {
        font-size: var(--font-size-sm);
      }

      .product__price {
       font-size: var(--font-size-sm);
       font-weight: var(--weight-book);
      }

      .rating-count {
        font-size: var(--spacing-xs);
      }
      
      td.cell {
        padding-inline-end: var(--spacing-s) !important;
      }
      
      tr.row {
        padding-block: var(--spacing-m) !important;
      }
      
      .product__select {
        width: 80%;
        margin: 0 auto;
        border: 0;
        border-radius: 0;
        border-bottom: 1px solid #D8D8D8;
        height: fit-content;
        padding-inline-end: 1.5rem;
      }
    }

    @media(min-width: 864px) {
      tr.row {
        padding-inline: var(--spacing-m);
      }

      tr.row--attribute {
        min-height: 72px;
        align-items: center;
      }

      tr.row--attribute .row-header {
        background-color: transparent;
      }

      tr.row--attribute:nth-child(odd) {
        background-color: var(--color-grey-200);
      }

      thead th, tbody td {
        padding-inline: var(--spacing-l) !important;
      }

      .attribute-name, .attribute-value {
        font-size: var(--font-size-m);
      }

      .attribute-name {
        font-weight: var(--weight-semi);
      }

      .product__select {
        font-size: var(--font-size-m);
      }

      .product .button {
        font-size: var(--font-size-m);
        padding: 0;
        height: 44px;
        padding-inline: var(--spacing-xl);
        font-weight: var(--weight-mid);
        margin-block-start: var(--spacing-m);
      }
    }
  `;for(const o of n){const d=o.shadowRoot;if(d){const t=document.createElement("style");t.textContent=u,d.appendChild(t);const r=o.closest(".comparison-table-wrapper"),l=((c=(s=(i=r==null?void 0:r.getAttribute("data-groups-to-show"))==null?void 0:i.split(","))==null?void 0:s.map(e=>e.trim().toLowerCase()))==null?void 0:c.filter(e=>!!e))??[];d.querySelectorAll(".row-group--body").forEach((e,a)=>{var m;if(a===0&&l.length===0){e.classList.add("visible");return}const g=e.querySelector(".group-name"),h=((m=g==null?void 0:g.textContent)==null?void 0:m.toLowerCase().trim())??"";(l.includes(h)||l.includes(`${a+1}`))&&e.classList.add("visible")}),r==null||r.classList.remove("visually-hidden")}}}function _(n,u=!1){const{cartDeliveryEstimatedShipping:i,cartDeliveryDateEstimate:s}=window.themeVars.strings.cart,c=new Date(n).getTime(),o=new Date().getTime(),d=c-o,t=Math.round(Math.floor(d/(1e3*60*60*24))/7),r=t<=1?t:t-1,l=t+1,p=`${i}: ${r} - ${l} ${window.themeVars.strings.cart.weeks}`;if(u)return l<1?s:`${p} ${window.themeVars.strings.cart.weeks}`;if(d>0){const e=`${i}: ${s}`;return t<1?e:p}}export{f as a,v as c,_ as s,w as u};
